import * as z from "zod";
import { Id } from "./ids.js";

export const MESSAGE_REACTIONS = ["👍", "👎", "❤️", "😂", "🎉", "😮"] as const;
export const MessageReactionSchema = z.enum(MESSAGE_REACTIONS);
export type MessageReaction = z.infer<typeof MessageReactionSchema>;

/** How a person rates a bot's reply, best first. */
export const MESSAGE_RATINGS = ["perfect", "good", "average", "bad"] as const;
export const MessageRatingSchema = z.enum(MESSAGE_RATINGS);
export type MessageRating = z.infer<typeof MessageRatingSchema>;

export const SetMessageRatingInput = z.object({
  botId: Id,
  messageId: Id,
  /** Null clears the caller's rating. */
  rating: MessageRatingSchema.nullable(),
});

export const MyMessageRatingsSchema = z.object({
  ratings: z.array(z.object({ messageId: z.string(), rating: MessageRatingSchema })),
});

/** Every rating the caller may review: a bot's owner sees its ratings, a Space admin all of them. */
export const RatingReviewInput = z.object({
  botId: Id.optional(),
  limit: z.number().int().min(1).max(500).default(100),
});
export const RatingReviewSchema = z.object({
  ratings: z.array(
    z.object({
      messageId: z.string(),
      botId: z.string(),
      userId: z.string(),
      rating: MessageRatingSchema,
      updatedAt: z.string(),
    }),
  ),
});
export type RatingReview = z.infer<typeof RatingReviewSchema>;

/** What one finished reply's run spent: tokens in → out, cost, model, and how long it took. */
export const RunUsageSchema = z.object({
  runId: z.string(),
  inputTokens: z.number().int().nonnegative(),
  outputTokens: z.number().int().nonnegative(),
  /** Null when no priced call reported a cost. */
  costUsd: z.number().nonnegative().nullable(),
  model: z.string().nullable(),
  durationMs: z.number().int().nonnegative().nullable(),
});
export type RunUsage = z.infer<typeof RunUsageSchema>;
export const RunUsageInput = z.object({
  botId: Id,
  runIds: z.array(Id).min(1).max(100),
});
